__webpack_require__.p = "/mental-texas-holdem/";